import React, { useEffect, useState } from 'react';
import { analyticsUserTrack } from '../config/analyticsTrack';
import Logo from './assets/logo.png'
import BlackLogo from './assets/BlackLogo.png'
import Config from '../helper/Config';
import { Link } from 'react-router-dom';
import bg from './assets/HowWeDoBg.png'
import HumanMachineCollaborationThroughTeqitPlatform from './assets/HumanMachineCollaborationThroughTeqitPlatform.png'
import TeqitEcosystemOverview from './assets/TeqitEcosystemOverview.png'
import "./Custom.css"
import Footer from './Footer';
import Header from './components/Header';


export default function HowWeDo(props) {
    const [showMenu, setShowMenu] = useState(false);


    useEffect(() => {
        analyticsUserTrack("Home", "Our Team");
        const handleScroll = () => {
            const scrollTop = window.scrollY;
            const shouldShow = scrollTop > 150;

            setShowMenu((prev) => {
                if (prev !== shouldShow) {
                    return shouldShow;
                }
                return prev;
            });
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);

    }, [])

    return <div className='may-2025 how-we-do'>
        <div className='block1' style={{ marginTop: 0 }}>
            <div className={`home-sticky-crop home ${showMenu ? "home-sticky-background" : ""}`} style={{ top: 0 }}>
                <Link to={Config.projectUrl + "/"} onClick={() => window.scrollTo(0, 0)}>
                    <img className='logo' src={showMenu ? Logo : BlackLogo} />
                </Link>
                {
                    showMenu && <Header />
                }
            </div>
        </div>
        <div className="full-screen-image">
            <div className="bg-image d-flex align-items-center justify-content-center">
                <img className='img-fluid' src={bg} alt="Teqbahn-How-we-do" style={{ maxHeight: "100%" }} />
            </div>
        </div>
        <div className='container'>
            <div className='heading-text montserrat-font-family text-center my-5'>
                Teqit - Human and Machine Collaboration for Global Solutions
            </div>
            <div className='text-center'>
                <img className='img-fluid' src={HumanMachineCollaborationThroughTeqitPlatform} style={{ maxHeight: "calc(100vh - 250px)"}}/>
            </div>
        </div>
        <div style={{ backgroundColor: "#ddebf2" }}>
            <div className='py-5'>
                <div className='key-features d-flex flex-column align-items-center'>
                    <div className='heading-text text-center montserrat-font-family mt-5' style={{ fontSize: "1.5em", borderBottom: "2px solid #000", paddingBottom: 10}}>
                        Teqit Advances Human + Machine Collaboration with Speed and Scalability
                    </div>
                    <div style={{ maxWidth: "75%", margin: "auto"}}>
                        <div className='heading-text pt-3 montserrat-font-family' style={{ fontSize: "1.5em" }}>
                            Key Features
                        </div>
                        <div className='teqit-advances details'>
                            <ul style={{ padding: 16 }}>
                                <li className='mb-2'>
                                    <b>Community-Led Innovation:</b> Solutions emerge from key partnerships and are evaluated by expert insiders.
                                </li>
                                <li className='mb-2'>
                                    <b>Carbon-Sensitive Architecture:</b> Advanced edge computing, bare-metal deployment, minimal external dependencies.
                                </li>
                                <li className='mb-2'>
                                    <b>Scalable Tech Stack:</b> From smartphones, tablets, desktops, to feature phones - our end to end system scales across all device types.
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer />
    </div>;
}
